(<template>
  <div id="homepage">
    <monument-list></monument-list>
    <div id="comments">
      <comments-newsfeed></comments-newsfeed>
      <reported-comments-newsfeed v-if="$session.exists()  && $route.path !=='/'"></reported-comments-newsfeed>
    </div>
  </div>
</template>)

(<script>
import MonumentList from '../components/Monument-List.vue'
import ReportedCommentsNewsfeed from '../components/Reported-Comments-Newsfeed.vue'
import CommentsNewsfeed from '../components/Comments-Newsfeed.vue'

export default {
  name: 'app',
  components: {
    'reported-comments-newsfeed': ReportedCommentsNewsfeed,
    'monument-list': MonumentList,
    'comments-newsfeed': CommentsNewsfeed
  }
}
</script>)

(<style>
#homepage {
  min-height: 800px;
  margin: 0px;
  padding: 0px;
  display: -webkit-flex;
  display:         flex;
}

@media screen and (max-width: 1200px) {
  #homepage {
    flex-direction: column;
  }
  #comments {
    flex-direction: row;
  }
}
</style>)



// WEBPACK FOOTER //
// src/components/Home-Page.vue